// extracted by css-extract-rspack-plugin
export default {"SectionTitle":"form-section_SectionTitle__kYe3-"};